import { each, head, isEqual, last, get, flatten, isArray, uniq, isNil } from '@antv/util';
import { View } from 'src/chart';
import { findItemsFromViewRecurisive } from '../../util/tooltip';
import { IShape, Point, ShapeAttrs } from '../../dependents';
import Element from '../../geometry/element';
import { LooseObject, TooltipCfg } from '../../interface';
import { getAngle, getSectorPath } from '../../util/graphics';
import Action from './base';

const DEFAULT_REGION_PATH_STYLE = {
  fill: '#CCD6EC',
  opacity: 0.3,
};

export function getItemsOfView(view: View, point: Point, tooltipCfg: TooltipCfg) {
  let items = findItemsFromViewRecurisive(view, point, tooltipCfg);
  if (items.length) {
    // ä¸å±
    items = flatten(items);
    for (const itemArr of items) {
      for (const item of itemArr) {
        const { x, y } = item.mappingData;
        item.x = isArray(x) ? x[x.length - 1] : x;
        item.y = isArray(y) ? y[y.length - 1] : y;
      }
    }

    const { shared } = tooltipCfg;
    // shared: false ä»£è¡¨åªæ¾ç¤ºå½åæ¾åå°ç shape çæ°æ®ï¼ä½æ¯ä¸ä¸ª view ä¼æå¤ä¸ª Geometryï¼æä»¥æå¯è½ä¼æ¾åå°å¤ä¸ª shape
    if (shared === false && items.length > 1) {
      let snapItem = items[0];
      let min = Math.abs(point.y - snapItem[0].y);
      for (const aItem of items) {
        const yDistance = Math.abs(point.y - aItem[0].y);
        if (yDistance <= min) {
          snapItem = aItem;
          min = yDistance;
        }
      }
      items = [snapItem];
    }

    return uniq(flatten(items));
  }

  return [];
}

/**
 * èæ¯æ¡ç Action. åªä½ç¨äº interval å schema geometry
 * @ignore
 */
class ActiveRegion extends Action {
  private items: any[];
  private regionPath: IShape;
  /**
   * æ¾ç¤º
   * @param {ShapeAttrs} style region-path çæ ·å¼
   * @param {number} appendRatio éç¨äºç¬å¡å°åæ ç³». å¯¹äº x è½´é linear ç±»å: é»è®¤ï¼0.25, x è½´ linear ç±»å: é»è®¤ 0
   * @param {number} appendWidth  éç¨äºç¬å¡å°åæ ç³». åç´ çº§å«ï¼ä¼åçº§ > appendRatio
   */
  public show(args?: { style: ShapeAttrs; appendRatio?: number; appendWidth?: number }) {
    const view = this.context.view;
    const ev = this.context.event;

    const tooltipCfg = view.getController('tooltip').getTooltipCfg();
    const tooltipItems = getItemsOfView(
      view,
      {
        x: ev.x,
        y: ev.y,
      },
      tooltipCfg
    );

    if (isEqual(tooltipItems, this.items)) {
      // å¦ææ¾åæ°æ®åä¸æ¬¡ç¸åï¼åä¸éå¤ç»å¶
      return;
    }
    this.items = tooltipItems;
    if (tooltipItems.length) {
      const xField = view.getXScale().field;
      const xValue = tooltipItems[0].data[xField];
      // æ ¹æ® x å¯¹åºçå¼æ¥æ¾ elements
      let elements: Element[] = [];
      const geometries = view.geometries;
      each(geometries, (geometry) => {
        if (geometry.type === 'interval' || geometry.type === 'schema') {
          const result = geometry.getElementsBy((ele) => {
            const eleData = ele.getData();
            return eleData[xField] === xValue;
          });

          elements = elements.concat(result);
        }
      });

      // æ ¹æ® bbox è®¡ç®èæ¯æ¡çé¢ç§¯åºå
      if (elements.length) {
        const coordinate = view.getCoordinate();

        let firstBBox = elements[0].shape.getCanvasBBox();
        let lastBBox = elements[0].shape.getCanvasBBox();
        const groupBBox: LooseObject = firstBBox;

        each(elements, (ele: Element) => {
          const bbox = ele.shape.getCanvasBBox();
          if (coordinate.isTransposed) {
            if (bbox.minY < firstBBox.minY) {
              firstBBox = bbox;
            }
            if (bbox.maxY > lastBBox.maxY) {
              lastBBox = bbox;
            }
          } else {
            if (bbox.minX < firstBBox.minX) {
              firstBBox = bbox;
            }
            if (bbox.maxX > lastBBox.maxX) {
              lastBBox = bbox;
            }
          }

          groupBBox.x = Math.min(bbox.minX, groupBBox.minX);
          groupBBox.y = Math.min(bbox.minY, groupBBox.minY);
          groupBBox.width = Math.max(bbox.maxX, groupBBox.maxX) - groupBBox.x;
          groupBBox.height = Math.max(bbox.maxY, groupBBox.maxY) - groupBBox.y;
        });

        const { backgroundGroup, coordinateBBox } = view;
        let path;
        if (coordinate.isRect) {
          const xScale = view.getXScale();

          let { appendRatio, appendWidth } = args || {};
          if (isNil(appendWidth)) {
            appendRatio = isNil(appendRatio) ? (xScale.isLinear ? 0 : 0.25) : appendRatio; // å¦æ x è½´æ¯æ°å¼ç±»åï¼å¦ç´æ¹å¾ï¼é»è®¤ä¸éè¦å é¢å¤çå®½åº¦
            appendWidth = coordinate.isTransposed ? appendRatio * lastBBox.height : appendRatio * firstBBox.width;
          }

          let minX: number;
          let minY: number;
          let width: number;
          let height: number;
          if (coordinate.isTransposed) {
            minX = coordinateBBox.minX;
            minY = Math.min(lastBBox.minY, firstBBox.minY) - appendWidth;
            width = coordinateBBox.width;
            height = groupBBox.height + appendWidth * 2;
          } else {
            minX = Math.min(firstBBox.minX, lastBBox.minX) - appendWidth;
            // ç´è§åæ ç³» éè½¬ç½®ï¼æå°å¼ç´æ¥å åæ ç³» minY
            minY = coordinateBBox.minY;
            width = groupBBox.width + appendWidth * 2;
            height = coordinateBBox.height;
          }

          path = [
            ['M', minX, minY],
            ['L', minX + width, minY],
            ['L', minX + width, minY + height],
            ['L', minX, minY + height],
            ['Z'],
          ];
        } else {
          const firstElement = head(elements);
          const lastElement = last(elements);
          const { startAngle } = getAngle(firstElement.getModel(), coordinate);
          const { endAngle } = getAngle(lastElement.getModel(), coordinate);
          const center = coordinate.getCenter();
          const radius = coordinate.getRadius();
          const innterRadius = coordinate.innerRadius * radius;
          path = getSectorPath(center.x, center.y, radius, startAngle, endAngle, innterRadius);
        }

        if (this.regionPath) {
          this.regionPath.attr('path', path);
          this.regionPath.show();
        } else {
          const style = get(args, 'style', DEFAULT_REGION_PATH_STYLE);
          this.regionPath = backgroundGroup.addShape({
            type: 'path',
            name: 'active-region',
            capture: false,
            attrs: {
              ...style,
              path,
            },
          });
        }
      }
    }
  }
  /**
   * éè
   */
  public hide() {
    if (this.regionPath) {
      this.regionPath.hide();
    }
    // this.regionPath = null;
    this.items = null;
  }
  /**
   * éæ¯
   */
  public destroy() {
    this.hide();
    if (this.regionPath) {
      this.regionPath.remove(true);
    }
    super.destroy();
  }
}

export default ActiveRegion;
